import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import ExtendedPlanColumns from './extendedPlanColumns';
import { WebPlanContext } from '../../utils/webPlanContext';
import './extendedPlansWidget.scss';

function ExtendedPlansWidget() {
    const { t } = useTranslation();
    const { currentWebPlan, setWebPlan } = useContext(WebPlanContext);

    return (
        <div className="extended-plans-columns-wrapper">
            <Row className="mb-3">
                <Col md={12} className="text-center">
                    <h3 className="plans-subtitle">{t('titles.payment-cycle')}</h3>
                    <Tabs
                        id="plans-tabs"
                        activeKey={currentWebPlan}
                        onSelect={(k) => setWebPlan(k)}
                    >
                        <Tab eventKey="one" title={`1 ${t('titles.year')}`}>
                            <ExtendedPlanColumns period={1} />
                        </Tab>
                        <Tab
                            eventKey="two"
                            title={
                                <span>
                                    2 {t('titles.years')} <sup>-10%</sup>
                                </span>
                            }
                        >
                            <ExtendedPlanColumns period={2} />
                        </Tab>
                        <Tab
                            eventKey="three"
                            title={
                                <span>
                                    3 {t('titles.years')} <sup>-15%</sup>
                                </span>
                            }
                        >
                            <ExtendedPlanColumns period={3} />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </div>
    );
}

export default ExtendedPlansWidget;
